import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Shield, XCircle, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import QuickNav from '@/components/QuickNav';

const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center p-4">
      <motion.div
        className="max-w-md w-full text-center"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
      >
        <div className="w-20 h-20 rounded-full bg-yellow-500/20 flex items-center justify-center mx-auto mb-6">
          <XCircle className="w-12 h-12 text-yellow-500" />
        </div>
        
        <h1 className="text-3xl font-bold text-white mb-4">
          Pagamento Cancelado
        </h1>
        
        <p className="text-gray-400 mb-8">
          Você cancelou o processo de pagamento. Nenhuma cobrança foi realizada.
        </p>
        
        <div className="space-y-3">
          <Button
            className="w-full bg-[#00FF94] text-black hover:bg-[#00CC76] rounded-full font-bold py-6"
            onClick={() => navigate('/pricing')}
          >
            Ver Planos
          </Button>
          <Button
            variant="outline"
            className="w-full border-white/10 text-white hover:bg-white/5 rounded-full"
            onClick={() => navigate('/')}
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Voltar ao Início
          </Button>
        </div>

        {/* Footer */}
        <div className="mt-12 flex items-center justify-center gap-2 text-gray-500">
          <Shield className="w-4 h-4" />
          <span className="text-sm">Evite Dívidas</span>
        </div>
      </motion.div>
      <QuickNav />
    </div>
  );
};

export default PaymentCancel;
